import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clienti from './pages/Clienti';
import Formazione from './pages/Formazione';
import TemplateOfferte from './pages/TemplateOfferte';
import Guida from './pages/Guida';
import Segnalazioni from './pages/Segnalazioni';
import TipologieOfferte from './pages/TipologieOfferte';
import Offerte from './pages/Offerte';
import Commesse from './pages/Commesse';
import CommessaDetail from './pages/CommessaDetail';
import Fatturazioni from './pages/Fatturazioni';
import Consulenti from './pages/Consulenti';
import OfferteConsulenti from './pages/OfferteConsulenti';
import CostiConsulenti from './pages/CostiConsulenti';
import FattureConsulenti from './pages/FattureConsulenti';
import GestioneSal from './pages/GestioneSal';
import GestioneUtenti from './pages/GestioneUtenti';
import PortaleEsterno from './pages/PortaleEsterno';

// Route che richiede autenticazione. staffOnly = admin o interno (gestionale completo);
// adminOnly = solo admin (es. gestione utenti)
function PrivateRoute({ children, staffOnly = false, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (staffOnly && user.ruolo === 'esterno') return <Navigate to="/portale" replace />;
  if (adminOnly && user.ruolo !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

// Route solo per non autenticati
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={user.ruolo === 'esterno' ? '/portale' : '/dashboard'} replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/portale" element={<PrivateRoute><PortaleEsterno /></PrivateRoute>} />
      <Route path="/" element={<PrivateRoute staffOnly><Layout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="clienti" element={<Clienti />} />
        <Route path="formazione" element={<Formazione />} />
        <Route path="template-offerte" element={<TemplateOfferte />} />
        <Route path="guida" element={<Guida />} />
        <Route path="segnalazioni" element={<Segnalazioni />} />
        <Route path="tipologie-offerte" element={<TipologieOfferte />} />
        <Route path="offerte" element={<Offerte />} />
        <Route path="commesse" element={<Commesse />} />
        <Route path="commesse/:id" element={<CommessaDetail />} />
        <Route path="fatturazioni" element={<Fatturazioni />} />
        <Route path="consulenti" element={<Consulenti />} />
        <Route path="offerte-consulenti" element={<OfferteConsulenti />} />
        <Route path="costi-consulenti" element={<CostiConsulenti />} />
        <Route path="fatture-consulenti" element={<FattureConsulenti />} />
        <Route path="sal" element={<GestioneSal />} />
        <Route path="utenti" element={<PrivateRoute adminOnly><GestioneUtenti /></PrivateRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
